import React from 'react';
import PropTypes from 'prop-types';

import SeeAllButton from './SeeAllButton';
import SectionHeader from './SectionHeader';
import SearchResults from '../../../components/Users/UserListItem/SearchResults/SearchResults';

const UserResults = ({
    results: { results: userResults, total } = {},
    url,
    isSingleSearch,
}) => {
    if (!total) return null;

    const unit = total === 1 ? 'Member' : 'Members';
    const btnText = `See all ${total} ${unit}`;
    const defaultIds = (userResults || []).map((r) => r.userId);

    return (
        <>
            <SectionHeader>Members ({total})</SectionHeader>
            <SearchResults
                btnText={btnText}
                url={url}
                defaultIds={defaultIds}
                results={{ user: { results: userResults } }}
                renderSeeAllButton={(props) => (
                    <SeeAllButton {...props} isSingleSearch={isSingleSearch} />
                )}
            />
        </>
    );
};

export default UserResults;

const userResultType = PropTypes.shape({
    hash: PropTypes.string,
    image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    isCommunityManager: PropTypes.bool,
    isHighlightedUser: PropTypes.bool,
    karmaScore: PropTypes.number,
    location: PropTypes.string,
    name: PropTypes.string,
    publicUrl: PropTypes.string,
    relation: PropTypes.shape({
        isFollowing: PropTypes.bool,
        connectionStatus: PropTypes.string,
    }),
    userId: PropTypes.number,
    username: PropTypes.string,
});

UserResults.propTypes = {
    results: PropTypes.shape({
        results: PropTypes.arrayOf(userResultType),
        total: PropTypes.number,
    }),
    url: PropTypes.string,
    isSingleSearch: PropTypes.bool.isRequired,
};
UserResults.defaultProps = {
    results: {
        results: [],
        total: null,
    },
    url: null,
};
